// Generated with util/create-component.js
import React, { useState, useEffect } from 'react'
import uuid from 'uuidv4'
import { ProgressProps } from './Progress.types'

import { Button } from '../../index'

const Progress: React.FC<ProgressProps> = ({ children, withNumber = false, current }) => {
    const [currentId, setCurrentId] = useState(current)
    //
    // const mapStateToChildren = React.Children.map(children, (child: React.ReactElement, i) => {
    //     return React.cloneElement(child, { show: child.props.id === currentId })
    // })

    const _children = React.Children.map(children, (child: React.ReactElement, i) => {
        if (React.isValidElement(child)) {
            // @ts-ignore
            return React.cloneElement(child, { index: i, current, withNumber, titleCount: children.length })
        }
        return null
    })

    // Get state for first progress item to be shown
    useEffect(() => {
        let initialItemId = null
        React.Children.forEach(_children, (child: React.ReactElement, i) => {
            if (child && !child.props.id) {
                throw Error("Progress: Ensure each ProgressItem child has a unique 'id' prop")
            }
            if (i === 0 || child.props.initial) {
                initialItemId = child.props.id
            }
        })

        setCurrentId(initialItemId)
    }, [])

    const renderProgressTitles = React.Children.map(_children, (child: React.ReactElement, i) => (
        <div key={i} className={`r-progress-title ${child.props.id === current ? 'r-active' : ''}`}>
            {child.props.title}
        </div>
    ))

    const getActiveChild = () => {
        return _children.find((x: React.ReactElement) => x.props.id === currentId)
    }

    const getNextActiveChild = () => {
        const currentActive: any = getActiveChild()
        return _children[currentActive.props.index + 1]
    }

    const getPrevActiveChild = () => {
        const currentActive: any = getActiveChild()
        return _children[currentActive.props.index - 1]
    }

    const onNext = () => {
        const activeItem: any = getActiveChild()
        let canNext = true
        if (activeItem.props.onNext) {
            canNext = activeItem.props.onNext()
        }
        const nextActiveItem: any = getNextActiveChild()
        if (canNext && nextActiveItem) {
            setCurrentId(nextActiveItem.props.id)
        }
    }

    const onBack = () => {
        const nextActiveItem: any = getPrevActiveChild()
        if (nextActiveItem) {
            setCurrentId(nextActiveItem.props.id)
        }
    }

    const progressContext: any = {
        onNext,
        onBack,
        currentId,
        setCurrentId,
    }

    return (
        <div data-testid='Progress' className='r-progress-container'>
            <div className='r-progress-titles'>{_children}</div>
            {/* <div className='r-progress-content'>{mapStateToChildren}</div> */}
        </div>
    )
}

export default Progress
